export const dashboard = {
  menu: {
    overview: 'Overview',
    profile: 'My Profile',
    applications: 'My Applications',
    cv: 'My CVs',
    alerts: 'Job Alerts',
    settings: 'Settings'
  },
  stats: {
    applications: 'Applications',
    profileViews: 'Profile Views',
    responses: 'Responses',
    savedJobs: 'Saved Jobs',
    thisMonth: 'This month',
    thisWeek: 'This week',
    pending: 'Pending',
    total: 'Total'
  },
  recentApplications: {
    title: 'Recent Applications',
    viewAll: 'View all'
  },
  status: {
    pending: 'Pending',
    inReview: 'In Review',
    reviewed: 'Reviewed',
    accepted: 'Accepted',
    rejected: 'Rejected'
  },
  profile: {
    title: 'My Profile',
    photo: 'Profile Photo',
    changePhoto: 'Change Photo',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    title: 'Professional Title',
    bio: 'Biography',
    experience: 'Experience',
    education: 'Education',
    linkedin: 'LinkedIn',
    portfolio: 'Portfolio',
    save: 'Save Changes'
  },
  applications: {
    title: 'My Applications',
    total: 'applications',
    filter: {
      all: 'All',
      pending: 'Pending',
      reviewed: 'Reviewed',
      accepted: 'Accepted',
      rejected: 'Rejected'
    },
    appliedOn: 'Applied on',
    viewJob: 'View Job',
    withdraw: 'Withdraw Application'
  },
  cv: {
    title: 'CV Management',
    uploadNew: 'Upload New CV',
    formats: 'PDF, DOC, DOCX (Max 5 MB)',
    myFiles: 'My Files',
    default: 'Default',
    uploaded: 'Uploaded on',
    download: 'Download',
    setDefault: 'Set as Default',
    delete: 'Delete'
  },
  alerts: {
    title: 'Job Alerts',
    create: 'Create Alert',
    newAlert: 'New Alert',
    alertName: 'Alert Name',
    keywords: 'Keywords',
    location: 'Location',
    frequency: 'Frequency',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    save: 'Save',
    cancel: 'Cancel',
    active: 'Active',
    inactive: 'Inactive',
    created: 'Created on',
    activate: 'Activate',
    deactivate: 'Deactivate',
    delete: 'Delete'
  },
  recommended: {
    title: 'Recommended Jobs',
    viewAll: 'View All Jobs',
    viewDetails: 'View Details'
  },
  settings: {
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive email notifications',
    jobAlerts: 'Job Alerts',
    jobAlertsDesc: 'Receive alerts for new job offers',
    applicationUpdates: 'Application Updates',
    applicationUpdatesDesc: 'Get notified of status changes',
    newsletter: 'Newsletter',
    newsletterDesc: 'Receive our monthly newsletter',
    privacy: 'Privacy',
    profileVisibility: 'Profile Visibility',
    public: 'Public',
    private: 'Private',
    recruitersOnly: 'Recruiters Only',
    searchable: 'Searchable Profile',
    searchableDesc: 'Allow recruiters to find your profile',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    passwordMismatch: 'Passwords do not match',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'This action is irreversible. All your data will be deleted.',
    deleteAccountButton: 'Delete My Account'
  }
};

export const candidates = {
  hero: {
    title: 'Find Your Next Job',
    subtitle: 'Thousands of opportunities await you. Create your profile and apply in just a few clicks.',
    findJob: 'Search Jobs',
    createAccount: 'Create Account'
  },
  upload: {
    title: 'Upload Your CV in Seconds',
    subtitle: 'Fill out the form below and upload your CV to get started',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    jobCategory: 'Job Category',
    selectCategory: 'Select a category',
    experience: 'Experience',
    selectExperience: 'Select your experience',
    exp01: '0-1 year',
    exp13: '1-3 years',
    exp35: '3-5 years',
    exp510: '5-10 years',
    exp10plus: '10+ years',
    availability: 'Availability',
    selectAvailability: 'Select your availability',
    immediate: 'Immediate',
    oneMonth: '1 month',
    twoMonths: '2 months',
    threeMonths: '3 months',
    cvFile: 'Your CV',
    clickToUpload: 'Click to upload',
    fileFormats: 'PDF, DOC or DOCX (Max 5 MB)',
    submit: 'Submit Application'
  },
  benefits: {
    title: 'Why Choose Travail Global?',
    subtitle: 'We support you at every step of your job search',
    benefit1Title: 'Personalized Search',
    benefit1Desc: 'Find offers that perfectly match your profile and aspirations',
    benefit2Title: 'Real-time Alerts',
    benefit2Desc: 'Be instantly notified of new opportunities that match you',
    benefit3Title: 'Optimized Profile',
    benefit3Desc: 'Create an attractive profile that highlights your skills and experience',
    benefit4Title: 'Application Tracking',
    benefit4Desc: 'Manage all your applications from a single, intuitive dashboard',
    benefit5Title: 'International Opportunities',
    benefit5Desc: 'Access job offers worldwide',
    benefit6Title: 'Personalized Support',
    benefit6Desc: 'Benefit from expert advice to optimize your applications'
  },
  cta: {
    title: 'Ready to Start Your Career?',
    subtitle: 'Join thousands of candidates who found their ideal job with Travail Global',
    register: 'Create My Account',
    international: 'International Recruitment'
  }
};

export const auth = {
  login: {
    title: 'Login',
    subtitle: 'Sign in to your account',
    candidate: 'Candidate',
    employer: 'Employer',
    email: 'Email',
    password: 'Password',
    remember: 'Remember me',
    forgot: 'Forgot password?',
    submit: 'Sign In',
    noAccount: 'Don\'t have an account?',
    register: 'Sign Up',
    welcomeTitle: 'Welcome to Travail Global',
    welcomeSubtitle: 'Your trusted recruitment platform'
  },
  register: {
    candidateTitle: 'Create Candidate Account',
    candidateSubtitle: 'Start your job search today',
    employerTitle: 'Create Employer Account',
    employerSubtitle: 'Find the best talent for your company',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    terms: 'I accept the',
    termsLink: 'terms of service',
    submit: 'Create Account',
    hasAccount: 'Already have an account?',
    login: 'Sign In',
    welcomeTitle: 'Join Travail Global',
    welcomeSubtitle: 'Thousands of opportunities await you',
    passwordMismatch: 'Passwords do not match'
  }
};